// import Vue from 'vue'
import { fb } from '../plugins/firebase'
import { momento } from '../plugins/moment'
import { limpiar } from '../mixins/limpiar'

export default {
  namespaced: true,
  state: {
    pedido: [],
    pedidosRealizados: [],
    pedidosCliente: [],
    filtros: {
      mes: momento().format('MM'),
      anio: momento().format('YYYY'),
      estado: 'TODOS'
    }
  },
  mutations: {
    pedidosCliente (state, p) {
      state.pedidosCliente = p
    },
    setRealizados (state, p) {
      state.pedidosRealizados = p
    },
    setFiltros (state, p) {
      state.filtros = p
    },
    setPedido (state, p) {
      state.pedido = p
      localStorage.setItem('pedido', JSON.stringify([]))
    },
    addToPedido (state, p) {
      let existe = state.pedido.find(sel => sel.id === p.id)
      if (!existe) {
        state.pedido.push(p)
        localStorage.setItem('pedido', JSON.stringify(state.pedido))
      }
    },
    removerDelPedido (state, p) {
      let i = state.pedido.findIndex(sel => sel.pedido === p)
      state.pedido.splice(i, 1)
      localStorage.setItem('pedido', JSON.stringify(state.pedido))
    },
    saveToLocal (state) {
      localStorage.setItem('pedido', JSON.stringify(state.pedido))
    },
    loadLocal (state) {
      if (localStorage.getItem('pedido')) {
        let pedido = JSON.parse(localStorage.getItem('pedido'))
        state.pedido = []
        if (pedido.length > 0) {
          pedido.forEach(item => {
            let fecha = momento(item.key, 'x').diff(momento(), 'days')
            if (fecha >= -3 || fecha === 0)
              state.pedido.push(item)
          })
        }
      }
    },
    cambiarEstado (state, p) {
      let index = state.pedidosRealizados.findIndex(sel => sel.id === p.pedido.id)
      state.pedidosRealizados[index].status = p.status
    }
  },
  actions: {
    guardarPedido (ctx, p) {
      return new Promise ((resolve, reject) => {
        let datos = {
          usuario: p.user.uid,
          rut: p.user.rut,
          completo: p.user.nombres + ' ' + p.user.apellidos,
          correo: p.user.correo,
          telefono: p.user.telefono,
          timestamp: momento().format(),
          fecha: momento().format('YYYY-MM-DD'),
          mes: momento().format('MM'),
          anio: momento().format('YYYY'),
          dia: momento().format('DD'),
          status: 'INGRESADA',
          pedido: p.pedido
        }
        fb.collection('cotizaciones').add(datos)
        .then(() => {
          ctx.commit('setPedido', [])
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    cargarPedidos (ctx) {
      return new Promise ((resolve, reject) => {
        fb.collection('cotizaciones').where('anio', '==', ctx.state.filtros.anio).where('mes', '==', ctx.state.filtros.mes).get()
        .then(results => {
          let all = []
          results.forEach(doc => {
            let book = doc.data()
            book.id = doc.id
            if (ctx.state.filtros.estado === 'TODOS')
              all.push(book)
            else if (ctx.state.filtros.estado === book.status)
              all.push(book)
          })
          let final = all.sort((a, b) => momento(b.timestamp).format('x') - momento(a.timestamp).format('x'))
          ctx.commit('setRealizados', final)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    cambiarEstado (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('cotizaciones').doc(p.pedido.id).update({status: p.status})
        .then(() => {
          ctx.commit('cambiarEstado', p)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    enviarVenta (ctx, p) {
      return new Promise ((resolve, reject) => {
        let datos = {
          status: 'INGRESADA WEB',
          fecha: momento().format('YYYY-MM-DD'),
          sucursal: 'Casa Matriz',
          origen: 'Web',
          // deberia ser uid no rut
          usuario: p.pedido.uid,
          cotizacion: p.pedido.id,
          fechaCotizacion: p.pedido.timestamp
        }
        let peds = []
        let promesas = []
        p.pedido.pedido.forEach(item => {
          let ped = {
            coleccion: item.coleccion,
            id: item.id,
            cantidad: item.cantidad,
            titulo: item.titulo,
            precio: 0,
            precioBase: 0,
            tipo: ''
          }
          if (item.nuevo && !item.usado)
            ped.tipo = 'nuevo'
          else if (!item.nuevo && item.usado)
            ped.tipo = 'usado'
          else 
            ped.tipo = ''
          let p = fb.collection('libros').doc(ped.id).get()
          if (ped.tipo !== '') {
            promesas.push(p)
            peds.push(ped)
          }
        })
        Promise.all(promesas)
        .then(solved => {
          let solvs = solved.map(item => {
            let a = item.data()
            a.id = item.id
            return a
          })
          let completados = peds.map(item => {
            if (item.tipo === 'nuevo') {
              item.precioBase = solvs.find(sel => sel.id === item.id).nuevoPrecio
            } else if (item.tipo === 'usado') {
              item.precioBase = solvs.find(sel => sel.id === item.id).usadoPrecio
            }
            item.precio = item.precioBase
            return item
          })
          datos.pedido = completados
          return fb.collection('ventas').where('cotizacion', '==', p.pedido.id).get()
        })
        .then(ans => {
          if (!ans.empty) {
            return resolve({existe: true, anadido: false})
          } else {
            ctx.commit('vnt/setVenta', datos.pedido, {root: true})
            return resolve({existe: false, anadido: true})
          }
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    pedidosCliente (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('cotizaciones').where('usuario', '==', p.usuario).get()
        .then(results => {
          let all = []
          results.forEach(doc => {
            let pedido = doc.data()
            pedido.id = doc.id
            all.push(pedido)
          })
          ctx.commit('pedidosCliente', all)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    }
  },
  getters: {
    checkExisteNuevo: (state) => (p) => { 
      let existe = state.pedido.findIndex(sel => sel.pedido === p + 'nuevo')
      if (existe === -1)
        return false
      else 
        return true
    },
    checkExisteUsado: (state) => (p) => { 
      let existe = state.pedido.findIndex(sel => sel.pedido === p + 'usado')
      if (existe === -1)
        return false
      else 
        return true
    },
    todos (state) {
      return state.pedido.sort((a, b) => {
        const aL = limpiar(a.titulo)
        const bL = limpiar(b.titulo)
        if (aL < bL)
          return -1 
        if (aL > bL)
          return 1
        return 0
      })
    },
    realizados: (state) => state.pedidosRealizados,
    pedidosCliente: (state) => state.pedidosCliente
  }
}
